import React from 'react';
import { Link } from '@reach/router';
import ImageGallery from "../components/ImageGallery";
import Footer from '../components/footer';


export default () => (
<div>
  <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'./img/witalyShipping3.jpg'})`}}>
    <div className='mainbreadcumb'>
      <div className='container-fluid'>
        <div className='row m-10-hor'>
          <div className='col-md-6'>
            <h1>Shipping</h1>
          </div>
          <div className='col-md-6'>
            <div className='list'>
              <Link className='link' to="/home">Home</Link>
              <span className='dash'>/</span>
              <span>Shipping</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className='container-fluid black'>
        <div className='row m-10-hor'>

        <div className='col-md-5'>
            <div className='heading'>
              Reliable<span className='br'></span> Effecient<span className='br'></span> Logisitcs
            </div>
          </div>

          <div className='col-md-7'>
            <div className='content'>
              Witaly Shipping provides reliable and efficient logistics
              solutions designed to move goods seamlessly across borders
              and markets. We specialize in safe handling, timely delivery,
              
            </div>
            <div className='content'>
              and end-to-end shipping services that support businesses and
              individuals with their import, export, and freight needs. With
              a focus on professionalism, transparency, and customer satisfaction,
              Witaly Shipping ensures every shipment is handled with care and precision.
            </div>
          </div>

        </div>
  </section>

  <section className='container-fluid black_more'>
    <div className='row m-10-hor'>
      <div className='col-12'>
        <div className='AppContainer'>
          <ImageGallery />
        </div>
      </div>
    
    </div>
  </section>

  <Footer />
</div>

);
